import React, { useState } from 'react';
import './css/TextExpander.css';

// TextExpander Component
const TextExpander = ({ text, wordLimit = 9 }) => {
    const [isExpanded, setIsExpanded] = useState(false); // State to manage text expansion
    const words = text.split(' '); // Split text into words
    const isLongText = words.length > wordLimit;

    // Function to handle toggling text expansion
    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    // Get the truncated version of the text, with ellipsis
    const truncatedText = words.slice(0, wordLimit).join(' ') + '...';
    return (
        <span>
            {isLongText ? (
                isExpanded ? (
                <>
                    {text} {/* Full text when expanded */}
                    <button
                    style={{ margin: '0.5rem' }}
                    className="toggle-button"
                    onClick={handleToggle}
                    >
                    Show Less
                    </button>
                </>
                ) : (
                <>
                    {truncatedText} {/* Truncated text when collapsed */}
                    <button className="toggle-button" onClick={handleToggle}>
                    Show More
                    </button>
                </>
                )
            ) : (
                text /* If text is shorter or equal to the word limit, display full text without a button */
            )}
        </span>
    );
};

export default TextExpander;